import { Component, Input, OnChanges, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';
import { ProjectnameService } from './service/projectname.service';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-projectname',
  templateUrl: './projectname.component.html',
  styleUrls: ['./projectname.component.css']
})
export class ProjectnameComponent implements OnInit, OnChanges {
  @Input() projectId: string;
  project:Project;
  projectList:Project[];
  constructor(
    private pns:ProjectnameService,
    private datastore:DatastoreService,
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.projectId && this.projectList){
      this.project = this.projectList.find(px => px.projectId.split('_')[0] == this.projectId.split('_')[0] )
    }
  }

  ngOnInit(): void {
  //   this.projectList = JSON.parse(SessionHelper.getMyProjectList());
  //   if(this.projectList){
  //     this.project = this.projectList.find(px => px.projectId.split('_')[0] == this.projectId.split('_')[0] )
  //   }else{
  //     this.pns.getPersonProjects(SessionHelper.getUserSub(),SessionHelper.getChoosenOrg()).pipe(untilDestroyed(this)).subscribe(pl => {
  //     this.projectList = pl;
  //     SessionHelper.setMyProjectList(JSON.stringify(this.projectList));
  //     this.project = this.projectList.find(px => px.projectId.split('_')[0]  == this.projectId.split('_')[0] )
  //   });
  //   }
  //   if(!this.project){
  //     this.pns.getProject(this.projectId.split('_')[0] ).pipe(untilDestroyed(this)).subscribe(p => {
  //       this.project = p;
  //     });
  //   }
  //   //console.log(this.project);
  this.datastore.projectList.pipe(untilDestroyed(this)).subscribe(plist =>{
    this.projectList = plist;
    if(this.projectList){
      this.project = this.projectList.find(px => px.projectId.split('_')[0] == this.projectId.split('_')[0] )
    }
   }
  );
  }
}
